import {throwError as observableThrowError, Observable} from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import {BaseService} from '../base.service';
import {Injectable, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Paging} from '../../models/latipay/paging.model';
import {Sorts} from '../../models/admin/sorts.model';

@Injectable()
export class AppPrizeItemService extends BaseService implements OnInit {

    constructor(public http: HttpClient) {
        super('app-prize-item', http);
    }

    ngOnInit(): void {
    }

    getAllAppFeedbackByPaging(searchCondition: string, sortOprions: Sorts, paging: Paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        const sortStr = sortOprions.getSortString();
        return this.http.get(`${this.url}${sortStr}${paging.getPagingStr()}${searchCondition}&sort=created,desc`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }


    getAllUserByPaging(searchCondition: string, id: string, paging: Paging, hasUser?: string) {
        let idSortStr = '&sort=issueDate,desc';
        const embededStr = '&embedded=prize';
        let str = '';
        if (hasUser === 'has') {
            str = '&f_prize.raffleId_op==&f_prize.raffleId=' + id;
        } else {
            str = '&f_userId=U&f_prize.raffleId_op==&f_prize.raffleId=' + id;
        }
        return this.http.get(`${this.url}?${paging.getPagingStr()}${this.embeddedStr + searchCondition + idSortStr + embededStr + str}`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)),);
    }

    getAllUserByPrizeIdByPaging(searchCondition: string, id: string, paging: Paging) {
        let idSortStr = '&sort=id,desc';
        const embededStr = '&embedded=prize';
        if (!searchCondition) {
            searchCondition = '';
        }
        let str = '&f_userId=U&f_prize.id_op==&f_prize.id=' + id;
        return this.http.get(`${this.url}?${paging.getPagingStr()}${this.embeddedStr + searchCondition + idSortStr + embededStr + str}`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)),);
    }

    getAllByBusinessIdByPaging(searchCondition: string, businessId: number, paging: Paging) {
        if (!searchCondition) {
            searchCondition = '';
        }

        return this.http.get(`${this.url}?${paging.getPagingStr()}${this.embeddedStr + searchCondition}&sort=id,desc` + (businessId ? `&f_businessId=${businessId}&f_businessId_op==` : '')).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    getAllByWalletIdsByPaging(walletIds: string[], searchCondition: string, paging: Paging) {
        const sortStr = '&sort=id,asc';
        let walletIdsStr = '';
        if (walletIds) {
            walletIds.forEach(id => {
                walletIdsStr += `&f_acceptedMerchants=${id}`;
            })
        }
        if (walletIdsStr) {
            walletIdsStr += '&f_acceptedMerchants_op=IN';
        }
        return this.http.get(`${this.url}?${paging.getPagingStr()}${walletIdsStr}${sortStr}${searchCondition}`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res))
        );
    }

    publishCouponById(id: string) {
        return this.http.post(`${this.url}/${id}/dispatch`, '').pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    updateStatus(id: number, enabled: number) {
        return this.http.post(`${this.url}/${id}/${enabled}/update-status`, '').pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    addBudget(id: number, budget: number) {
        return this.http.post(`${this.url}/${id}/${budget}/add-budget`, '').pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    activatePrize(id: number) {
        return this.http.post(`${this.url}/${id}/activate-prize`, '').pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    redeemPrize(id: number) {
        return this.http.post(`${this.url}/${id}/redeem-prize`, '').pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }


}
